// extracted by mini-css-extract-plugin
export default {"scope":"GPfkS","more-count":"LgPZK","scope--is-show-more":"_7KnRO","first-record":"_8n3fW","first-record--has-show-more":"r0tk8","all-records":"syYSq vPP5U hzH4T","record":"P9qSR"};